import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmChevronRightCircle = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-chevron-right-circle",
    width: "1em",
    height: "1em",
    "data-icon": "icon-llm-chevron-right-circle",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      d: "M23.5,9.7c-0.5-2.3-1.6-4.4-3.2-6c-1.6-1.6-3.7-2.8-6-3.2S9.7,0.3,7.5,1.1s-4,2.4-5.3,4.3c-1.3,1.9-2,4.2-2,6.5 c0,3.1,1.2,6.1,3.4,8.3c2.2,2.2,5.2,3.4,8.3,3.4c2.3,0,4.6-0.7,6.5-2c1.9-1.3,3.4-3.1,4.3-5.3C23.7,14.3,24,12,23.5,9.7z M21.4,13.9 c-0.4,1.9-1.3,3.6-2.6,4.9c-1.3,1.3-3.1,2.3-4.9,2.6c-1.9,0.4-3.8,0.2-5.6-0.5c-1.8-0.7-3.3-2-4.3-3.5C3,15.8,2.4,13.9,2.4,12 c0-2.5,1-5,2.8-6.8C7,3.4,9.5,2.4,12,2.4c1.9,0,3.8,0.6,5.3,1.6c1.6,1.1,2.8,2.6,3.5,4.3C21.6,10.1,21.8,12,21.4,13.9z M10.9,7.4 l4.8,4.6l-4.8,4.6l-1.5-1.5l3.3-3.1L9.4,8.9L10.9,7.4z"
    })
  }));
});
IconLlmChevronRightCircle.displayName = 'IconLlmChevronRightCircle';

export { IconLlmChevronRightCircle };
//# sourceMappingURL=llm-chevron-right-circle.js.map
